@if (!m_loading) {
    <h1 style="position: relative; top: 5px; left: -10px" class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
}
<div mat-dialog-content class="custom-height">
    <div class="row">
        <div class="option">
            @if (m_loading) {
                <app-loading [type]="1" [size]="'60px'" [style]="{ 'margin-top': '150px' }"></app-loading>
            } @else {
                <div class="fade-in">
                    <div class="user-overview" [@staggerAnimation]>
                        <div [style.grid-area]="'chart1'">
                            @if (m_loadingStation) {
                                <app-loading [type]="5" [size]="'60px'"></app-loading>
                            } @else {
                                <div class="fade-in connection-wrapper">
                                    <div>player monitoring</div>
                                    @if (m_stationData?.props?.send_notification) {
                                        <div>
                                            <mat-icon class="connection" fxLayoutGap="2px">verified</mat-icon>
                                        </div>
                                    } @else {
                                        <mat-icon class="connection" fxLayoutGap="2px">unpublished</mat-icon>
                                    }
                                </div>
                            }
                        </div>
                        <div [style.grid-area]="'chart2'">
                            @if (m_loadingStation) {
                                <app-loading [type]="5" [size]="'60px'"></app-loading>
                            } @else {
                                <div class="fade-in connection-wrapper">
                                    <div>{{ "general.stationHealth" | transloco }}</div>
                                    <div>
                                        @if (!m_stationData.stat.$.connection || m_stationData.stat.$.connection === '0') {
                                            <mat-icon class="connection" fxLayoutGap="2px">error</mat-icon>
                                        } @if (m_stationData.stat.$.connection === '1') {
                                            <mat-icon class="connection" fxLayoutGap="2px">verified_user</mat-icon>
                                        } @if (m_stationData.stat.$.connection === '2') {
                                            <mat-icon class="connection" fxLayoutGap="2px">warning_amber</mat-icon>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        <div [style.grid-area]="'chart3'">
                            <div class="snap-wrapper">
                                <app-station-snapshot [enabled]="m_snapStatus"></app-station-snapshot>
                                @if (!m_waitingOnSnap) {
                                    <button class="snapIcon fade-in" mat-icon-button matTooltip="{{ 'general.screenCapture' | transloco }}" (click)="takeSnap()">
                                        <mat-icon>add_a_photo</mat-icon>
                                    </button>
                                }
                            </div>
                        </div>
                        <div [style.grid-area]="'chart4'" class="map-wrapper">
                            @if (!m_mapReady) {
                                <app-loading [type]="2" [size]="'60px'" [style]="{ 'margin-top': '150px' }"></app-loading>
                            } @else {
                                <app-station-map [filterByStation]="m_stationData" [setZoom]="4"></app-station-map>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
